<template>
  <div class="home">
    <div class="banner_container">
      <img class="banner" src="../assets/images/5G.jpg" alt="" />
    </div>
    <div class="input_container">
      <van-form ref="searchForm">
        <van-cell-group>
          <van-field v-model="keyWord" name="keyword" placeholder="请输入ICCID/SIM/充值卡号/绑定手机号/设备号" right-icon="scan"
            clearable :rules="[{ required: true, message: '请输入' }]" @click-right-icon="handleScanClick" />
        </van-cell-group>
      </van-form>
    </div>
    <div class="history_search">
      <span>历史搜索</span>
    </div>

    <div class="history">
      <van-cell v-for="(item, index) in historyList" :key="index" :title="item" icon="clock-o"
        @click="selectHistoryItem(item)">
        <template #right-icon>
          <van-icon name="cross" class="search-icon" @click="handleDelete(index)" />
        </template>
      </van-cell>
    </div>

    <div class="query">
      <van-button type="primary" size="large" color="linear-gradient(90deg, #30b4ff, #09a7fd 100%, #198cfe 0)"
        @click="queryDevice">查询</van-button>
    </div>
  </div>
</template>

<script>
import { getDeviceInfo, getDeviceNoByMobile } from "@/api/device"
export default {
  name: 'LoginView',
  components: {},
  data() {
    return {
      keyWord: '',
      historyList: []
    }
  },
  created() {
    // 加载缓存
    const history = localStorage.getItem('searchHistory');
    if (history) {
      this.historyList = JSON.parse(history);
    }
    const { scanResult } = this.$route.params;
    console.log("扫码", scanResult);
    if (!!scanResult) {
      this.keyWord = scanResult;
    }
  },
  mounted() {
    console.log("mounted");
  },
  methods: {
    handleScanClick() {
      this.$router.replace({
        path: '/qrCodeScan',
      })
    },
    handleDelete(index) {
      this.historyList.splice(index, 1)
      localStorage.setItem('searchHistory', JSON.stringify(this.historyList))
    },
    queryDevice() {
      this.$refs.searchForm
        .validate()
        .then(() => {
          console.log('校验通过')
          const keyWord = this.keyWord.trim();
          // 判断是否手机号
          if (this.validatePhone(keyWord)) {
            getDeviceNoByMobile(keyWord).then(deviceNo => {
              console.log("查询手机号", deviceNo);
              this.cacheHistory(this.historyList, keyWord);
              this.goDeviceHome(deviceNo);
            }).catch((error) => {
              console.log('查询手机号失败', error);
              if (error.status == 1004013000) {
                this.$toast("该手机号未绑定设备");
              }
            });
          } else {
            this.getDevice(keyWord);
          }
        })
        .catch(errors => {
          console.log('校验失败', errors)
        })
    },
    getDevice(deviceNo) {
      getDeviceInfo(deviceNo).then(res => {
        console.debug("device", res);
        this.cacheHistory(this.historyList, deviceNo)
        this.goDeviceHome(deviceNo);
      }).catch(error => {
        console.log("查询设备信息失败", error);
        if (error.status == '508') {
          this.$toast('请输入正确的ICCID/SIM/DEVICE/IMEI/充值卡号/绑定的手机号');
        }
      });
    },
    selectHistoryItem(item) {
      this.keyWord = item
    },
    cacheHistory(arr, item) {
      // 复制原数组（避免直接修改原数组，遵循immutable原则）
      const newArr = [...arr];
      // 默认比较函数：严格相等
      const isEqual = ((a, b) => a === b);

      // 1. 检查是否存在相同元素，存在则删除
      const index = newArr.findIndex(itemInArr => isEqual(itemInArr, item));
      if (index !== -1) {
        newArr.splice(index, 1); // 删除原位置的元素
      }

      // 2. 在头部添加新元素
      newArr.unshift(item);

      // 3. 若长度超过10，删除尾部超出的元素
      if (newArr.length > 10) {
        newArr.splice(10); // 保留前10个，删除后面的
      }

      localStorage.setItem('searchHistory', JSON.stringify(newArr))
    },
    goDeviceHome(deviceNo) {
      this.$router.push({
        path: '/deviceHome',
        query: {
          _t: deviceNo
        }
      });
    },
    validatePhone(phone) {
      const reg = /^1[3-9]\d{9}$/;
      // 先去除前后空格，再校验
      return reg.test(phone.trim());
    }
  },
  mounted() { }
}
</script>

<style scoped>
.home {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: start;
  width: 100vw;
  height: 100vh;
  background-color: #f7f7f7;
}

.banner_container {
  width: 100%;
}

.banner {
  width: 100%;
  height: auto;
  object-fit: cover;
}

.input_container {
  width: 100%;
  padding: 20px 0;
}

.input_container .van-cell-group {
  border-top: 1px solid #f0f0f0;
  border-bottom: 1px solid #f0f0f0;
}

.input_container .van-cell {
  background-color: #fff;
}

.input_container .van-cell ::v-deep .van-field__control {
  padding: 5px 0;
}

.van-cell-group,
.van-cell {
  background-color: #f7f7f7;
}

.van-cell-group--inset {
  margin: 0;
  height: 52px;
}

::v-deep .van-icon-scan {
  font-size: 26px !important;
  font-weight: 600;
}

.history_search {
  width: 100%;
}

.history_search span {
  font-size: 16px;
  font-family: 'PingFang SC';
  padding: 0 16px;
}

.history {
  width: 100%;
  flex: 1;
}

.query {
  width: 100%;
  margin-bottom: 15vh;
  padding: 0 16px;
}

.query button {
  border-radius: 4px;
}
</style>
